<template>
  <div
    :id="panelId"
    class="hc-panel"
    role="tabpanel"
    :aria-labelledby="ariaLabelledby || undefined"
  >
    <div v-if="title || $slots['header-actions']" class="hc-panel__header">
      <div class="hc-panel__header-text">
        <h2 class="hc-panel__title">{{ title }}</h2>
        <p v-if="subtitle" class="hc-panel__subtitle">{{ subtitle }}</p>
      </div>
      <div v-if="$slots['header-actions']" class="hc-panel__actions">
        <slot name="header-actions" />
      </div>
    </div>
    <div class="hc-panel__body" :class="bodyClass">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardPanel',
  props: {
    panelId: { type: String, default: '' },
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    ariaLabelledby: { type: String, default: '' },
    bodyClass: { type: String, default: '' },
  },
};
</script>
